import React from 'react';
import TurnkeyServicesSection from '../components/sections/TurnkeyServicesSection';
import Footer from '../components/sections/Footer';

const TurnkeyServices = () => {
  return (
    <div className="min-h-screen bg-white pt-20">
      <TurnkeyServicesSection />
      <Footer />
    </div>
  );
};

export default TurnkeyServices;
